import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    cardHolderName: Yup.string()
      .trim("SPACE_VALIDATION")
      .strict(true)
      .required("CARDHOLDER_VAL")
      .nullable(),
    zipCode: Yup.string()
      .matches(/^[0-9]+$/, "ONLY_DIGITS_VALIDATION")
      .min(5, "ZIP_FIVE_CHAR_VALIDATION")
      .max(5, "ZIP_FIVE_CHAR_VALIDATION")
      .required("ZIP_CODE_VALIDATION"),
    address1: Yup.string()
      .trim("SPACE_VALIDATION")
      .strict(true)
      .required("ADDRESS_1_VAL"),
    address2: Yup.string().trim("SPACE_VALIDATION").strict(true),
    isDefaultPayment: Yup.boolean()
      .oneOf([true], "DEF_PAY_VAL")
      .required("DEF_PAY_VAL"),
    state: Yup.string()
      .trim("SPACE_VALIDATION")
      .strict(true)
      .required("STATE_VAL")
      .nullable(),
    city: Yup.string()
      .trim("SPACE_VALIDATION")
      .strict(true)
      .required("CITY_VAL")
      .nullable(),
    cardElement: Yup.mixed().required("CARD_DETAILS_VAL"),
  }),
  handleSubmit: (values) => {},
  mapPropsToValues: (props) => ({
    isDefaultPayment: true,
    cardElement: null,
  }),
  displayName: "CustomValidationForm",
  enableReinitialize: true,
  isInitialValid: false,
});

export default formikEnhancer;
